<app-unit-product-creation-flow [ean]="ean" [reference]="reference" [pendingProduct]="pendingProduct"></app-unit-product-creation-flow>
